import { ScheduledOrderSlot } from '../../../../types/availability';
import useStore from '../../../../hooks/context/useStore';
import useOngoingOrder from '../../../../hooks/context/useOngoingOrder';
import React, { memo, useMemo } from 'react';
import collect from 'collect.js';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import useHelpers from '../../../../hooks/utility/useHelpers';
import moment from 'moment-timezone';
import { Stringable } from '../../../../services/utils/Stringable';

type Props = {
  hour: number;
  slots: ScheduledOrderSlot[];
};

export default function HourSlots({ hour, slots }: Props) {
  const { order_settings } = useStore().storeData;
  const { orderData, updateOrderData } = useOngoingOrder();

  const { formatTime } = useHelpers();

  const slotsPerHour = 60 / order_settings.scheduled_orders_time_slot_interval;

  const _slots = useMemo(
    () =>
      collect()
        .times(
          slotsPerHour,
          (index) => (index - 1) * order_settings.scheduled_orders_time_slot_interval,
        )
        .map((minute) =>
          collect(slots).first((item) => moment(item.start_time).minute() === minute),
        ),
    [slots, slotsPerHour],
  );

  const Slot = memo(
    ({ slot, selectedTime }: { slot: ScheduledOrderSlot; selectedTime: null | string }) =>
      slot ? (
        <Button
          color={slot.start_time === selectedTime ? 'primary' : undefined}
          variant={slot.start_time === selectedTime ? 'solid' : 'outlined'}
          onClick={() => updateOrderData('schedule_info.scheduled_for', slot.start_time)}
          className="mt-sm"
          size="large"
          key={slot.start_time}
        >
          {formatTime(slot.start_time)}
        </Button>
      ) : (
        <Button type="text" size="large" className="mt-sm">
          <CloseOutlined />
        </Button>
      ),
  );

  return (
    <div className="flex flex-col">
      <h6 className="mx-auto">{new Stringable(hour.toString()).padLeft(2, '0').toString()}:00</h6>
      {_slots.map((item, index) => (
        <Slot
          slot={item}
          selectedTime={orderData.schedule_info.scheduled_for}
          key={`hour-${hour}-slot-${index}`}
        />
      ))}
    </div>
  );
}
